import { Typography, Divider } from "@mui/material";
import { useTheme } from "@mui/material/styles";
import { Link } from "react-router-dom";

const PrivacyPolicy = () => {
  const theme = useTheme();
  const styles = {
    intro: {
      color: `${theme.palette.primary.main}`,
    },
    para: {
      padding: "5px 0px 5px 20px",
    },
  };

  return (
    <div style={{ padding: "50px 80px" }}>
      <Typography variant="h4">Privacy Policy</Typography>

      <br />
      <Divider />
      <br />

      <Typography variant="h6" paragraph style={styles.intro}>
        <strong>1. Introduction</strong>
      </Typography>

      <Typography variant="body1" paragraph style={styles.para}>
        Welcome to ACC Copilot, an application designed to enhance your
        experience with Autodesk Construction Cloud (ACC) and WhatsApp. Your
        privacy is important to us, and we are committed to protecting the
        information you share with us. This Privacy Policy outlines how we
        collect, use, and safeguard your data when you use ACC Copilot.
      </Typography>

      <Typography variant="h6" paragraph style={styles.intro}>
        <strong>2. Information We Collect</strong>
      </Typography>

      <Typography variant="body1" paragraph style={styles.para}>
        We collect the following types of information:
      </Typography>

      <Typography variant="body1" paragraph style={styles.para}>
        <strong style={styles.intro}>
          2.1 Autodesk Construction Cloud Information:
        </strong>{" "}
        ACC Copilot requires access to your Autodesk Construction Cloud account
        to provide its intended functionalities. The information we collect
        includes project details, drawings, documents, and other relevant
        project-related data. We do not store or access any information beyond
        what is necessary for the application's functionality.
      </Typography>

      <Typography variant="body1" paragraph style={styles.para}>
        <strong style={styles.intro}>2.2 WhatsApp Information:</strong> For ACC
        Copilot's integration with WhatsApp, we collect and store your phone
        number to facilitate communication features. We do not access or store
        your WhatsApp messages, call logs, or any other personal communication
        content.
      </Typography>

      <Typography variant="h6" paragraph>
        <strong style={styles.intro}>3. How We Use Your Information</strong>
      </Typography>

      <Typography variant="body1" paragraph style={styles.para}>
        We use the collected information for the following purposes:
      </Typography>

      <Typography variant="body1" paragraph style={styles.para}>
        <strong style={styles.intro}>
          3.1 Autodesk Construction Cloud Information:
        </strong>{" "}
        To provide ACC Copilot's core functionalities related to project
        management, collaboration, and document sharing within Autodesk
        Construction Cloud.
      </Typography>

      <Typography variant="body1" paragraph style={styles.para}>
        <strong style={styles.intro}>3.2 WhatsApp Information:</strong> To
        enable communication features within ACC Copilot using your WhatsApp
        account.
      </Typography>

      <Typography variant="h6" paragraph>
        <strong style={styles.intro}>4. Data Security</strong>
      </Typography>

      <Typography variant="body1" paragraph style={styles.para}>
        We take security seriously and implement measures to protect your data
        from unauthorized access, disclosure, alteration, and destruction. We
        use industry-standard security practices and protocols to ensure the
        confidentiality and integrity of your information.
      </Typography>

      <Typography variant="h6" paragraph style={styles.intro}>
        <strong>5. Data Sharing</strong>
      </Typography>

      <Typography variant="body1" paragraph style={styles.para}>
        We do not sell, trade, or otherwise transfer your information to third
        parties without your consent. However, we may share your information
        with trusted third parties who assist us in providing and improving ACC
        Copilot's services, subject to confidentiality agreements.
      </Typography>

      <Typography variant="h6" paragraph style={styles.intro}>
        <strong>6. Consent</strong>
      </Typography>

      <Typography variant="body1" paragraph style={styles.para}>
        By using ACC Copilot, you consent to the terms outlined in this Privacy
        Policy and agree to the collection and use of information as described
        herein.
      </Typography>

      <Typography variant="h6" paragraph style={styles.intro}>
        <strong>7. Changes to Privacy Policy</strong>
      </Typography>

      <Typography variant="body1" paragraph style={styles.para}>
        We reserve the right to update and modify this Privacy Policy at any
        time. Changes will be effective immediately upon posting on our website
        or within the ACC Copilot application. Please check this Privacy Policy
        periodically for updates.
      </Typography>

      <Typography variant="h6" paragraph style={styles.intro}>
        <strong>8. Contact Information</strong>
      </Typography>

      <Typography variant="body1" paragraph style={styles.para}>
        If you have any questions or concerns about this Privacy Policy or your
        data, please contact us at{" "}
        <Link
          to="mailto:info@cctech.co.in"
          style={{
            color: `${theme.palette.primary.main}`,
            textDecoration: "none",
          }}
        >
          info@cctech.co.in
        </Link>
        .
      </Typography>

      <Typography variant="body1">
        Thank you for trusting ACC Copilot with your information.
      </Typography>
    </div>
  );
};

export default PrivacyPolicy;
